export default {
  namespaced: true,

  state: () => ({
    isStatus: false,
    isLogin: false,
    expireDate: '',
    userName: null,
    refresh: '',
    rpHmId: null,
    sessionId: null,
    householdUUId: null,
  }),

  mutations: {
    getSessionId(state, data){
      console.log('saveSessionIdVuex:', data);
      state.sessionId = data;
    },
    changeLogin(state, data){
      console.log('Vuex:', data);
      state.isStatus = data.isStatus;
      state.isLogin = data.isLogin;
      state.expireDate = data.chanExpireDate;
      state.userName = data.userName;
      state.refresh = data.refresh;
      state.rpHmId = data.rpHmId
    },
    storeHouseholdUUId(state, data) {
      console.log('toreHouseholdUUId:', data);
      state.householdUUId = data;
    },
  },

  actions: {
    // getDetailData({ commit, state }, message) {
    //   state.cancelTokens.forEach((token) => {
    //     if (token.source.cancel) {
    //       token.source.cancel(message);
    //     }
    //   });
    //   commit('clearCancelToken');
    // },
  },

  getters: {
    getChangeLogin(state) {
      return state.isLogin;
    },
    getExpireDate(state) {
      return state.expireDate;
    },
    getUserName(state) {
      return state.userName;
    },
    getIsStatus(state) {
      return state.isStatus;
    },
  },
};
